import {
  h2,
  h3,
  paragraph,
} from "@/styles/typography";
import styled from "styled-components";

const Div = styled.div`
  position: relative;

  p {
    position: absolute;
    color: white;
    top: 0;
    padding: 1rem 0.75rem 0.5rem 1rem;
    right: 0;
    font-family: Avenir next;
    text-transform: capitalize;
    font-size: 0.5rem;
    opacity: 0.5;
  }
`;

const P = styled.p`
  position: absolute;
  color: white;
  top: 5%;
  padding: 1rem 0.75rem 0.5rem 1rem;
  right: 5%;
  font-family: Avenir next;
  text-transform: capitalize;
  font-size: 0.5rem;
  z-index: 1;
  opacity: 0.5;

  @media ${({ theme }) => theme.breakpoints.md} {
    font-size: 0.4rem;
  }
  @media ${({ theme }) => theme.breakpoints.sm} {
    font-size: 0.3rem;
  }
`;

const Container = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(min(400px, 100%), 1fr));
  gap: 50px;

  align-items: center;

  width: 100%;
  min-height: 400px;
  margin-bottom: ${({ theme }) => theme.margins.bottomMobile};
`;

const Title = styled(h2)`
  color: ${({ theme }) => theme.colors.primary};
  text-transform: uppercase;
`;

const AccentTitle = styled.span`
  color: ${({ theme }) => theme.textColors.tertiary};
`;

const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 0px 70px 0 0;
  gap: 50px;
  height: 100%;

  @media ${({ theme }) => theme.breakpoints.md} {
    padding: 0;
  }
  @media ${({ theme }) => theme.breakpoints.sm} {
    display: block;
  }
`;

const ImagesWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 30px;
  padding: 70px 0;

  .gatsby-image {
    width: 100%;
    height: 100%;
    object-fit: fill;
    object-position: center;
  }

  @media ${({ theme }) => theme.breakpoints.md} {
    padding: 0;
  }
`;

const Image = styled.img`
  width: 100%;
  height: 100%;
  max-height: 310px;
  opacity: 0;
  object-fit: fill;
  object-position: center;
`;

const ImageText = styled.div`
  position: absolute;
  display: flex;
  flex-direction: column;
  width: calc(100% - 100px);
  gap: 10px;
  top: 70%;
  left: 50px;
  transform: translateY(-50%);
  transition: all 0.3s ease-in-out;
  z-index: 2;
  pointer-events: none;
`;

const Line = styled.div`
  border: 0px solid ${({ theme }) => theme.textColors.secondary};
  width: 0%;
  height: 0px;
  transition: all 0.3s ease-in-out;
`;

const ImageOverlay = styled.div`
  display: block;
  position: absolute;
  width: 100%;
  height: 100%;
  background: black;
  opacity: 0.4;
  top: 0;
  z-index: 1;
  transition: all 0.3s ease-in-out;
`;

const ImageContainer = styled.a`
  overflow: hidden;
  max-height: 310px;
  position: relative;
  
  @media ${({ theme }) => theme.breakpoints.md} {
    margin: 0 auto;
    max-height: 410px;
    aspect-ratio: 1/1;
    width: 100%;
  }

  @media ${({ theme }) => theme.breakpoints.hover} {
    &:hover {
      ${ImageText} {
        top: 30% !important;
      }
      ${ImageOverlay} {
        opacity: 1;
        background-color: ${({ theme }) => theme.colors.primary};
      }
      ${Line} {
        width: 100%;
        border: 2px solid ${({ theme }) => theme.textColors.secondary};
      }
    }
  }
`;

const Link = styled(h3)`
  width: fit-content;
  max-width: 370px;
  display: flex;
  text-transform: uppercase;
  flex-direction: column;
  color: ${({ theme }) => theme.textColors.secondary};
  text-decoration: none;
  pointer-events: none;
`;

const SubtitleWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: relative;
  width: 100%;
  gap: 20px;
  padding-bottom: 30px;
`;

const Subtitle = styled(paragraph)`
  color: ${({ theme }) => theme.textColors.secondary};
  text-transform: uppercase;
`;

const S = {
  SubtitleWrapper,
  Container,
  Title,
  AccentTitle,
  TextWrapper,
  Line,
  Div,
  P,
  Image,
  ImageOverlay,
  ImagesWrapper,
  ImageContainer,
  Link,
  Subtitle,
  ImageText,
};

export default S;
